import { mockedErrorResponseGameOffline, mockedFaultyRedirectResponse, mockedRedirectResponse } from '../mocks';
import { ErrorResponse, RedirectResponse } from '../response';
import { RedirectAction } from '../actions';

const successRedirectMock: RedirectAction<undefined> = async (): Promise<RedirectResponse | ErrorResponse> => {
	return Promise.resolve(mockedRedirectResponse);
};

const failRedirectMock: RedirectAction<undefined> = async (): Promise<RedirectResponse | ErrorResponse> => {
	return Promise.resolve(mockedFaultyRedirectResponse);
};

const failErrorMock: RedirectAction<undefined> = async (): Promise<RedirectResponse | ErrorResponse> => {
	return Promise.resolve(mockedErrorResponseGameOffline);
};

export const logoutMocks: {
	successRedirect: RedirectAction<undefined>;
	failRedirect: RedirectAction<undefined>;
	failError: RedirectAction<undefined>;
} = {
	successRedirect: successRedirectMock,
	failRedirect: failRedirectMock,
	failError: failErrorMock
};
